import React, { useEffect, useState } from 'react';
import {
  Container,
  Typography,
  Card,
  CardContent
} from '@mui/material';

import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import "bootstrap-icons/font/bootstrap-icons.css";

import '../common.scss';
import { useSelector } from "react-redux";

import config from '../../config';
import Progressbar from './Progressbar';

function CreateVehicleRepo() {

  const { agreementNo } = useParams();

  const userInfo = useSelector((state) => state.userInfo);

  const userId = userInfo?.id;

  const decodedAgreementNo = atob(agreementNo);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [repoCurrentStep, setRepoCurrentStep] = useState("Pending");

  // --- PRELOADER: tracks POST request in-flight state ---
  const [postLoading, setPostLoading] = useState(false);

  const [formData, setFormData] = useState({

    agreement_no: '',
    customer_name: '',
    mobile: '',

    make: '',
    model: '',
    vehicle_year: '',
    registration_number: '',
    mileage: '',

    repo_reason: 'Section 9'

  });

  useEffect(() => {

    fetchVehicleDetails();
    fetchRepoProgress();
  }, []);

  const fetchVehicleDetails = async () => {

  try {

    // OLD API
    const res = await fetch(
      `${config.API_BASE_URL}getVehicleRepoDetails/${decodedAgreementNo}`
    );

    const result = await res.json();

    // NEW API
    console.log("decodedAgreementNo", decodedAgreementNo);
    const vehicleRes = await fetch(
      `${config.API_BASE_URL}getAllCloudVehicleDetails/${decodedAgreementNo}`
    );

    const vehicleResult = await vehicleRes.json();
    console.log("Vehicle Result", vehicleResult);
    

    if (result.status) {

      const vehicleData = vehicleResult?.data || {};

const apiVehicleData =
  vehicleData?.api_response || {};

setFormData({

  agreement_no:
    result.data.AgreementNo || '',

  customer_name:
    apiVehicleData.OwnerName ||
    vehicleData.OwnerName ||
    result.data.contact_name ||
    '',

  mobile:
    result.data.mobile || '',

  make:
    vehicleData.vehicle_type_name || '',

  model:
    apiVehicleData.VehicleId || '',

  vehicle_year:
    apiVehicleData.MfgYear || '',

  registration_number:
    apiVehicleData.RegistrationNo || '',

  mileage:
    result.data.mileage || '',

  repo_reason:
    'Section 9'

});

      // setFormData({

      //   agreement_no: result.data.AgreementNo || '',

      //   customer_name:
      //     vehicleData.OwnerName ||
      //     result.data.contact_name ||
      //     '',

      //   mobile: result.data.mobile || '',

      //   make:
      //     vehicleData.VehicleTypeId ||
      //     result.data.make ||
      //     '',

      //   model:
      //     vehicleData.VehicleId ||
      //     result.data.model ||
      //     '',

      //   vehicle_year:
      //     vehicleData.MfgYear ||
      //     result.data.vehicle_year ||
      //     '',

      //   registration_number:
      //     vehicleData.RegistrationNo ||
      //     result.data.registration_number ||
      //     '',

      //   mileage:
      //     result.data.mileage ||
      //     '',

      //   repo_reason: 'Section 9'

      // });


    } else {

      toast.error(result.message);

    }

  } catch (error) {

    console.log(error);

    toast.error("Failed to fetch details");

  } finally {

    setLoading(false);

  }
};

const fetchRepoProgress = async () => {

  try {

    const res = await fetch(

      `${config.API_BASE_URL}get-repo-progress-flow?agreement_no=${decodedAgreementNo}`

    );

    const result = await res.json();

    if (result.status) {

      setRepoCurrentStep(
        result.current_step
      );

    }

  } catch (error) {

    console.log(error);

  }

};

  // const fetchVehicleDetails = async () => {

  //   try {

  //     const res = await fetch(
  //       `${config.API_BASE_URL}getVehicleRepoDetails/${decodedAgreementNo}`
  //     );

  //     const result = await res.json();

  //     if (result.status) {

  //       setFormData({

  //           agreement_no: result.data.AgreementNo || '',
  //           customer_name: result.data.contact_name || '',
  //           mobile: result.data.mobile || '',

  //           make: result.data.make || '',
  //           model: result.data.model || '',
  //           vehicle_year: result.data.vehicle_year || '',
  //           registration_number: result.data.registration_number || '',
  //           mileage: result.data.mileage || '',

  //           repo_reason: 'Section 9'

  //         });

  //     } else {

  //       toast.error(result.message);

  //     }

  //   } catch {

  //     toast.error("Failed to fetch details");

  //   } finally {

  //     setLoading(false);

  //   }
  // };

  const handleChange = (e) => {

    const { name, value } = e.target;

    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

  };

  const handleSave = async () => {

  if (
    !formData.make ||
    !formData.model ||
    !formData.registration_number
  ) {

    toast.error("Please fill mandatory fields");
    return;

  }

  // --- PRELOADER: show overlay before POST request ---
  setPostLoading(true);

  try {

    const payload = {

      ...formData,

      user_id: userId

    };

    const res = await fetch(
      `${config.API_BASE_URL}createVehicleRepo`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
      }
    );

    const result = await res.json();

    if (result.status) {

      toast.success(result.message);

      // navigate(
      //   `/dashboard/repo-conditions-checklist/${result.repo_id}`
      // );

      const encryptedRepoId = btoa(result.repo_id);

      navigate(
        `/dashboard/repo-conditions-checklist/${encryptedRepoId}`
      );

    } else {

      toast.error(result.message);

    }

  } catch (error) {

    console.log(error);

    toast.error("Failed to save");

  } finally {

    // --- PRELOADER: hide overlay after POST finishes ---
    setPostLoading(false);

  }

};

return (
  <Container>

    {/* --- PRELOADER OVERLAY: shown during POST request --- */}
    {postLoading && (
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: 'rgba(255,255,255,0.85)',
          zIndex: 9999,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          backdropFilter: 'blur(3px)'
        }}
      >
        {/* Spinner */}
        <div
          style={{
            width: '56px',
            height: '56px',
            border: '5px solid #e0e0e0',
            borderTop: '5px solid #1976d2',
            borderRadius: '50%',
            animation: 'spin 0.8s linear infinite'
          }}
        />
        <p style={{ marginTop: '18px', fontWeight: 600, color: '#1976d2', fontSize: '15px' }}>
          Saving, please wait...
        </p>
        {/* Skeleton shimmer strips */}
        {[1,2,3].map(i => (
          <div
            key={i}
            style={{
              width: '320px',
              height: '14px',
              borderRadius: '6px',
              marginTop: '10px',
              background: 'linear-gradient(90deg,#e0e0e0 25%,#f5f5f5 50%,#e0e0e0 75%)',
              backgroundSize: '400% 100%',
              animation: 'shimmer 1.4s infinite'
            }}
          />
        ))}
        <style>{`
          @keyframes spin { to { transform: rotate(360deg); } }
          @keyframes shimmer { 0%{background-position:100% 0} 100%{background-position:-100% 0} }
        `}</style>
      </div>
    )}
    {/* --- END PRELOADER OVERLAY --- */}


    <div className="flex-container mb-3">

      <Typography variant="h4">
        Create Vehicle Repo
      </Typography>

    </div>
    <div className="mb-4">

  <Progressbar currentStep={repoCurrentStep} />

</div>

    <div id="main-wrap">

      <form>

        <div className="row">

          {/* Agreement Number */}
          <div className="col-md-4">

            <div className="form-group">

              <label>
                <span>Agreement Number</span>

                <input
                  type="text"
                  className="form-control"
                  value={formData.agreement_no}
                  readOnly
                />

              </label>

            </div>

          </div>

          {/* Customer Name */}
          <div className="col-md-4">

            <div className="form-group">

              <label>
                <span>Customer Name</span>

                <input
                  type="text"
                  className="form-control"
                  value={formData.customer_name}
                  readOnly
                />

              </label>

            </div>

          </div>

          {/* Mobile */}
          <div className="col-md-4">

            <div className="form-group">

              <label>
                <span>Mobile Number</span>

                <input
                  type="text"
                  className="form-control"
                  value={formData.mobile}
                  readOnly
                />

              </label>

            </div>

          </div>

          {/* Make */}
          <div className="col-md-4">

            <div className="form-group">

              <label>
                <span>
                  Make <a style={{ color: "red" }}>*</a>
                </span>

                <input
                  type="text"
                  className="form-control"
                  name="make"
                  value={formData.make}
                  onChange={handleChange}
                />

              </label>

            </div>

          </div>

          {/* Model */}
          <div className="col-md-4">

            <div className="form-group">

              <label>
                <span>
                  Model <a style={{ color: "red" }}>*</a>
                </span>

                <input
                  type="text"
                  className="form-control"
                  name="model"
                  value={formData.model}
                  onChange={handleChange}
                />

              </label>

            </div>

          </div>

          {/* Year */}
          <div className="col-md-4">

            <div className="form-group">

              <label>
                <span>Year</span>

                <input
                  type="text"
                  className="form-control"
                  name="vehicle_year"
                  value={formData.vehicle_year}
                  onChange={handleChange}
                />

              </label>

            </div>

          </div>

          {/* Registration Number */}
          <div className="col-md-6">

            <div className="form-group">

              <label>
                <span>
                  Registration Number <a style={{ color: "red" }}>*</a>
                </span>

                <input
                  type="text"
                  className="form-control"
                  name="registration_number"
                  value={formData.registration_number}
                  onChange={handleChange}
                />

              </label>

            </div>

          </div>

          {/* Mileage */}
          <div className="col-md-6">

            <div className="form-group">

              <label>
                <span>Mileage</span>

                <input
                  type="text"
                  className="form-control"
                  name="mileage"
                  value={formData.mileage}
                  onChange={handleChange}
                />

              </label>

            </div>

          </div>

          {/* Reason */}
          <div className="col-md-6">

            <div className="form-group">

              <label>
                <span>Reason for Intake</span>

                <input
                  type="text"
                  className="form-control"
                  value={formData.repo_reason}
                  readOnly
                />

              </label>

            </div>

          </div>

          {/* Save Button */}
          <div className="col-md-12">

            <div className="form-group mb-0 text-end">

              {/* --- PRELOADER: button disabled while POST is in-flight --- */}
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleSave}
                disabled={postLoading}
                style={{
                  minWidth: "140px",
                  opacity: postLoading ? 0.7 : 1
                }}
              >
                {postLoading ? 'Saving...' : 'Save'}
              </button>

            </div>

          </div>

        </div>

      </form>

    </div>

  </Container>
);
}

export default CreateVehicleRepo;